module.exports = __webpack_public_path__ + "img/gzhj_15.977bd43e.jpg";